import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import { ga } from '../../ga';

import { Clock } from '../../utils';
import { cueTimeSeconds } from '../../utils/broadcast';
import RefluxModelListenerMixin from '../../mixins/reflux-model-listener-mixin';

export default createClass({
  displayName: 'VideoIndex',

  contextTypes: {
    model: PropTypes.object,
  },

  propTypes: {
    cues: PropTypes.array,
  },

  // cue times are stored as absolute media times, but display and bounds-checking
  // happen on the player timeline, which shifts once the playlist (and its
  // EXT-X-BOXCAST-OFFSET) loads. listen to playback progress so the list corrects
  // itself when that happens.
  refluxModelListeners: {
    Actions: [{ on: 'TimeUpdate', trigger: 'onTimeUpdate' }],
  },

  mixins: [RefluxModelListenerMixin],

  getInitialState: function () {
    return { displaySignature: null };
  },

  onTimeUpdate: function () {
    // re-render only when something that affects the cue display has changed.
    const signature = (this.props.cues || []).map((c) => this.cueDisplayLabel(c)).join('|');
    if (signature !== this.state.displaySignature) {
      this.setState({ displaySignature: signature });
    }
  },

  cuePlayerTime: function (cue) {
    const { mediaOffset } = this.context.model;
    const absoluteTime = cueTimeSeconds(cue);
    return mediaOffset ? mediaOffset.toPlayerTime(absoluteTime) : absoluteTime;
  },

  cueDisplayLabel: function (cue) {
    return this.isCueInBounds(cue) ? Clock.durationFormatted(this.cuePlayerTime(cue)) : '';
  },

  // cues that fall outside the boundaries of the content (before the trim point of a
  // recording, or past its end) are not shown.
  isCueInBounds: function (cue) {
    const playerTime = this.cuePlayerTime(cue);
    if (playerTime < 0) return false;
    const duration = this.getDuration();
    return !duration || playerTime <= duration;
  },

  getDuration: function () {
    const { player } = this.context.model;
    try {
      return (player && player.getDuration()) || 0;
    } catch (e) {
      return 0;
    }
  },

  render: function () {
    const cues = (this.props.cues || []).filter((c) => this.isCueInBounds(c));
    return (
      <div className="boxcast-playlist-list">
        <ul>{cues.map((c, idx) => this.renderCue(c, idx))}</ul>
      </div>
    );
  },

  renderCue: function (cue, idx) {
    let className = 'boxcast-playlist-item boxcast-selectable';
    return (
      <li key={idx} className={className} style={{ minHeight: 'auto' }}>
        <p style={{ float: 'right' }}>({this.cueDisplayLabel(cue)})</p>
        <h3>
          <a href="#" onClick={(e) => this.switchTo(e, cue)}>
            {cue.name}
          </a>
        </h3>
      </li>
    );
  },

  switchTo: function (e, cue) {
    const { Actions } = this.context.model;
    e.preventDefault();
    Actions.SeekTo(cueTimeSeconds(cue));
    ga('send', 'event', 'cue', 'switchTo');
  },
});
